// extracted by mini-css-extract-plugin
export default {"root":"NoJS-module__root___i9Ott"};